import { Link, Navigate } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useApi } from "../api/api-context";
import { meQuery } from "../api/platform";
import { CenteredPage } from "../components/centered-page";

// Nach dem Login: Wohin? Keine Mitgliedschaft -> Onboarding, genau eine ->
// direkt in den Mandanten, mehrere -> Auswahl (Entscheidung 29/35).
export function SelectPage() {
  const { t } = useTranslation();
  const api = useApi();
  // useSuspenseQuery: Daten sind garantiert da (der Router-Loader hat sie
  // vorab geladen); Laden und Fehler behandelt der Router.
  const { data: me } = useSuspenseQuery(meQuery(api));

  const [first] = me.memberships;
  if (!first) return <Navigate to="/onboarding" replace />;
  if (me.memberships.length === 1) {
    return <Navigate to="/t/$tenant" params={{ tenant: first.subdomain }} replace />;
  }

  return (
    <CenteredPage account>
      <div className="flex flex-col gap-4">
        <div>
          <h1 className="text-xl text-ink">{t("select.title")}</h1>
          <p className="text-sm text-ink-muted">{t("select.subtitle")}</p>
        </div>
        <ul className="flex flex-col gap-2">
          {me.memberships.map((m) => (
            <li key={m.tenantId}>
              <Link
                to="/t/$tenant"
                params={{ tenant: m.subdomain }}
                className="flex items-center justify-between rounded-md border border-line px-4 py-3 hover:bg-page"
              >
                <span className="font-medium text-ink">{m.name}</span>
                <span className="text-xs text-ink-muted">{t(`roles.${m.role}`)}</span>
              </Link>
            </li>
          ))}
        </ul>
        <Link to="/onboarding" className="text-sm text-link-fg hover:underline">
          {t("select.create")}
        </Link>
      </div>
    </CenteredPage>
  );
}
